/**
 * Step 6 — Reflection on hunger
 *
 * Spec: specs/onboarding-rebuild.md → Act 1 step 6
 *
 * Variant scaffolding retired 2026-05-14 — synthesis is production.
 */

import HungerReflectionSynthesis from './HungerReflection.synthesis'

export default function HungerReflectionStep({
  topStruggle = 'staying consistent',
  struggles,
  onContinue,
}) {
  return (
    <HungerReflectionSynthesis
      topStruggle={topStruggle}
      struggles={struggles}
      onContinue={onContinue}
    />
  )
}
